module.exports = __webpack_public_path__ + "img/138.4116cf3e.jpg";